import { useState } from 'react';
import Auth from '../services/Auth';
import { GoogleTagManager } from '../helpers';
import useSetUser from './useSetUser';

const UseRefreshToken = () => {
  const setUser = useSetUser();
  const [isValidToken, setIsValidToken] = useState(undefined);

  const validTokenHandler = () => {
    const validToken = Auth.validExpiredToken();

    if (validToken === null) {
      GoogleTagManager.pushToDataLayer({
        event: 'pagina-virtual',
        page: '/miwom.wom.cl',
        pageName: 'MIWOM_ONLOAD',
      });
      setIsValidToken(false);
    } else if (!validToken) {
      const validRefreshToken = Auth.validRefreshToken();
      if (!validRefreshToken) {
        GoogleTagManager.pushToDataLayer({
          event: 'pagina-virtual',
          page: '/miwom.wom.cl',
          pageName: 'MIWOM_ONLOAD',
        });
        setIsValidToken(false);
      } else {
        Auth.updateToken().then(([res]) => {
          setUser(res);
          setIsValidToken(true);
        });
      }
    } else setIsValidToken(true);
  };

  return [isValidToken, validTokenHandler];
};

export default UseRefreshToken;
